import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthMirrorService {
  /**
   * This service is a workaround to avoid circular dependencies on AuthService <-> SecureStoreService
   */
  public authService: AuthService;

  constructor() {}
}
